import { FormattedMessageDiv, IconAlert } from '@odmonorepo/core-components';
import { getLDR } from 'merchant-api/spiceroad';
import { Collapse } from 'react-bootstrap';

export const LdrNotification = () => {
  const { loanDocRequest, ldrLoading } = getLDR(true);
  const showNotification = !ldrLoading && loanDocRequest != null;

  let loanRequestType = '';
  let variant;
  if (loanDocRequest?.some((ldr) => ldr.classification === 'CLOSING' && (ldr.status === 'REQUESTED' || ldr.status === 'REJECTED'))) {
    loanRequestType = 'ldrRequested';
    variant = 'warning';
  }
  else if (loanDocRequest?.some((ldr) => ldr.classification === 'CLOSING' && ldr.status === 'MERCHANT_RESPONSE_SUBMITTED')) {
    loanRequestType = 'ldrSubmitted';
    variant = 'info';
  }
  else {
    return null;
  }


  return (
    <Collapse in={showNotification} mountOnEnter={true} unmountOnExit={true}>
      <div>
        {showNotification &&
          <IconAlert className="m-0" variant={variant}>
            <FormattedMessageDiv className="fw-bold fs-6" id={`notification.title.${loanRequestType}`} />
            <FormattedMessageDiv id={`notification.message.${loanRequestType}`} />
          </IconAlert>
        }
      </div>
    </Collapse>
  );
};
